module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "padded"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.showTable) ? _c('data-table', {
    attrs: {
      "title": "Invoices",
      "table-ref": "invoices",
      "url": "invoices",
      "fields": _vm.fields,
      "sort-field": "invoiceType"
    },
    scopedSlots: _vm._u([{
      key: "odue",
      fn: function(props) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDue(props.rowData.amountPaid, props.rowData.total))
          }
        })]
      }
    }, {
      key: "view",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary",
            "icon": "fa fa-chevron-right",
            "round": ""
          },
          on: {
            "click": function($event) {
              return _vm.showDetails(props.rowData)
            }
          }
        }, [_vm._v("\n                View\n              ")])]
      }
    }], null, false, 2248098910)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('contractor-invoice-table')], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "duration": 200
    }
  }, [(!_vm.showTable) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "fa fa-chevron-left"
    },
    on: {
      "click": function($event) {
        _vm.showTable = true
      }
    }
  }, [_vm._v(" Back to Invoices")]), _vm._v(" "), _c('invoice-details', {
    attrs: {
      "row-data": _vm.invData
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d930ed5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/InvoicingView.vue
// module id = 1320
// module chunks = 0